<template>
  <div id="E0-2">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <h1 class="tit1">サイズ入力</h1>
            <div v-if="this.errorMessage.text" class="error_message">{{this.errorMessage.text}}</div>
            <ul class="lst_register">
              <li>
                <div class="cnt">
                  <div class="ins_wrap">
                    <div class="bir">
                      <span class="unit">W</span>
                      <input  v-model="sizeForm.kgFdW" type="text" id="width" name="width" class="int" @keypress="validateNumber">
                    </div>
                    <div class="bir">
                      <span class="unit">H</span>
                      <input  v-model="sizeForm.kgFdH" type="text" id="height" name="height" class="int" @keypress="validateNumber">
                    </div>
                    <div class="bir">
                      <span class="unit">D</span>
                      <input  v-model="sizeForm.kgFdD" type="text" id="depth" name="depth" class="int" @keypress="validateNumber">
                    </div>
                    <div class="bir">
                      <span class="unit">Image</span>
                      <input  type="file" id="depth" name="depth" class="int" @change="fileChange">
                    </div>
                  </div>
                  <div v-if="this.errors['kgFdW']" class="error_message">{{this.errors['kgFdW']}}</div>
                  <div v-if="this.errors['kgFdH']" class="error_message">{{this.errors['kgFdH']}}</div>
                  <div v-if="this.errors['kgFdD']" class="error_message">{{this.errors['kgFdD']}}</div>
                </div>
              </li>
            </ul>
            <div class="btn_area">
              <a class="btn1" @click="btnCreateClick1()">作成(setsize)</a>
            </div>
            <div class="btn_area">
              <a class="btn1" @click="btnCreateClick2()">作成(createplan)</a>
            </div>
            <br/>
            <br/>
            <div class="btn_area">
              <a class="btn1" @click="transitionUnity()">Unity遷移</a>
            </div>
            <br/>
            <br/>
            <div class="btn_area">
              <a class="btn1" @click="btnOrderClick()">見積書画面(デバッグ用)</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import * as Check from '../../utils/Check'
import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      sizeForm: {
        kgFdId: '',
        kgFdCode: '',
        kgFdW: 0,
        kgFdH: 0,
        kgFdD: 0,
        kgCgImage: null
      },
      targetPlan: {},
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    init: function () {
      let targetPlanData = App.getLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA)
      this.sizeForm.kgFdId = targetPlanData.kgFdId
      this.sizeForm.kgFdCode = targetPlanData.kgFdCode
      this.sizeForm.kgFdW = targetPlanData.kgFdW
      this.sizeForm.kgFdH = targetPlanData.kgFdH
      this.sizeForm.kgFdD = targetPlanData.kgFdD
      this.targetPlan = targetPlanData
    },
    btnCreateClick1: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errors = {}
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      if (!this.validation()) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      axios.post(KG_URL.PLANNING + '/set-size', this.sizeForm)
        .then(response => {
          console.log(response)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            console.log('callback for create')
          }
          // ローカルストレージを削除
          App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
          App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
          App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    btnCreateClick2: async function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errors = {}
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      if (!this.validation()) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      await axios.post(KG_URL.PLANNING + '/createplan', this.sizeForm)
        .then(response => {
          console.log(response)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            console.log('callback for create')
          }
          // ローカルストレージを削除
          App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
          App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
          App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
        // .finally(() => {
        //   this.$refs.loadingModalRef.showModal(false)
        //   this.submitDisable = false
        // })
      if (!this.sizeForm.kgCgImage) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      let payload = new FormData()
      console.log('type:' + this.sizeForm.kgCgImage.type)
      console.log('name:' + this.sizeForm.kgCgImage.name)
      payload.append('kgCgImage', new Blob([this.sizeForm.kgCgImage], {type: this.sizeForm.kgCgImage.type}), this.sizeForm.kgCgImage.name)
      await axios.post(KG_URL.PLANNING + '/cgupload', payload)
        .then(response => {
          console.log(response)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            console.log('callback for create')
          }
          // ローカルストレージを削除
          App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
          App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
          App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    btnOrderClick: function () {
      // TODO 見積書画面遷移のための仮の関数。後に削除
      this.$router.push('/kagull/order/input')
    },
    transitionUnity: function () {
      console.log('Call Unity.call(\'kagull_app\')')
      /* eslint-disable */
      Unity.call('kagull_app')
    },
    validation: function () {
      let ret = true
      // TODO: フィラー入力有無など不明なため一旦Dのみ仮実装
      if (this.sizeForm.kgFdD < this.targetPlan.kgFdMinD) {
        this.errors['kgFdD'] = 'Dの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.sizeForm.kgFdD > this.targetPlan.kgFdMaxD) {
        this.errors['kgFdD'] = 'Dの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      return ret
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    fileChange: function(event) {
      this.sizeForm.kgCgImage = event.target.files[0]
    }
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/FpSize.vue